/* Tea Lab collection page: filter drawer, sorting and pagination without a full page reload,
   plus the reveal of product cards as they scroll into view.
   Every link and form also works on its own, so if anything here fails the page simply loads normally. */
(function () {
  if (customElements.get('tea-lab-collection')) return;

  class TeaLabCollection extends HTMLElement {
    connectedCallback() {
      if (this._on) return;
      this._on = true;
      var self = this;
      this._id = this.getAttribute('data-id');
      this._click = function (e) { self.onClick(e); };
      this._submit = function (e) { self.onSubmit(e); };
      this._change = function (e) { self.onChange(e); };
      this._closed = function (e) { if (e.target && e.target.matches && e.target.matches('dialog[data-drawer]')) self.unlock(); };
      this._cancel = function (e) {
        if (e.target && e.target.matches && e.target.matches('dialog[data-drawer]')) { e.preventDefault(); self.closeDrawer(); }
      };
      this._pop = function () { if (self._pushed) self.load(location.href, false, 'count'); };
      this.addEventListener('click', this._click);
      this.addEventListener('submit', this._submit);
      this.addEventListener('change', this._change);
      this.addEventListener('close', this._closed, true);
      this.addEventListener('cancel', this._cancel, true);
      window.addEventListener('popstate', this._pop);
      this.observeCards();
    }

    disconnectedCallback() {
      this._on = false;
      this.removeEventListener('click', this._click);
      this.removeEventListener('submit', this._submit);
      this.removeEventListener('change', this._change);
      this.removeEventListener('close', this._closed, true);
      this.removeEventListener('cancel', this._cancel, true);
      window.removeEventListener('popstate', this._pop);
      if (this._ac) this._ac.abort();
      if (this._io) { this._io.disconnect(); this._io = null; }
      document.documentElement.classList.remove('tlc-lock');
    }

    drawer() { return this.querySelector('dialog[data-drawer]'); }
    form() { return this.querySelector('form[data-form]'); }

    openDrawer(btn) {
      var d = this.drawer();
      if (!d || d.open) return;
      this._opener = btn || null;
      if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
      document.documentElement.classList.add('tlc-lock');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    }

    animated() {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      return this.getAttribute('data-anim') === 'on' && !reduce;
    }

    /* Slides the drawer out, then closes it. Returns a promise that settles once it is closed. */
    closeDrawer(silent) {
      var self = this;
      var d = this.drawer();
      if (!d || !d.open) { this.unlock(); return Promise.resolve(); }
      if (this._closeP) return this._closeP;
      var finished = false;
      var timer = null;
      var onEnd = null;
      var resolveIt = null;
      var finish = function () {
        if (finished) return;
        finished = true;
        clearTimeout(timer);
        if (onEnd) d.removeEventListener('animationend', onEnd);
        d.classList.remove('is-closing');
        if (d.isConnected && d.open) { if (typeof d.close === 'function') d.close(); else d.removeAttribute('open'); }
        self.unlock();
        if (!silent && self._opener && self._opener.isConnected) self._opener.focus();
        self._closeP = null;
        if (resolveIt) resolveIt();
      };
      var p = new Promise(function (resolve) { resolveIt = resolve; });
      if (!this.animated()) { finish(); return p; }
      onEnd = function (e) { if (e.target === d) finish(); };
      d.addEventListener('animationend', onEnd);
      d.classList.add('is-closing');
      var name = window.getComputedStyle(d).animationName;
      if (!name || name === 'none') { finish(); return p; }
      timer = setTimeout(finish, 700);
      this._closeP = p;
      return p;
    }

    unlock() {
      document.documentElement.classList.remove('tlc-lock');
      var b = this.querySelector('[data-open-filters]');
      if (b) b.setAttribute('aria-expanded', 'false');
    }

    onClick(e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      var open = t.closest('[data-open-filters]');
      if (open) { e.preventDefault(); this.openDrawer(open); return; }
      if (t.closest('[data-close]')) { e.preventDefault(); this.closeDrawer(); return; }
      if (t.matches('dialog[data-drawer]')) { this.closeDrawer(); return; }
      var a = t.closest('a[data-nav], .tlc__pager a');
      if (!a || !this.contains(a)) return;
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (a.target && a.target !== '_self') return;
      var u;
      try { u = new URL(a.href, location.href); } catch (err) { return; }
      if (u.origin !== location.origin) return;
      e.preventDefault();
      this.load(u.href, true, a.closest('.tlc__pager') ? 'top' : 'count');
    }

    onSubmit(e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches('form[data-form]')) return;
      e.preventDefault();
      this.load(this.urlFrom(f), true, 'count');
    }

    onChange(e) {
      var t = e.target;
      if (t && t.matches && t.matches('[data-sort]')) {
        var f = this.form();
        if (f) this.load(this.urlFrom(f), true, 'sort');
      }
    }

    urlFrom(form) {
      var u = new URL(form.getAttribute('action') || location.pathname, location.href);
      var q = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (typeof v === 'string' && v !== '') q.append(k, v); });
      var sort = this.querySelector('[data-sort]');
      if (sort && sort.value && !q.has('sort_by')) q.append('sort_by', sort.value);
      u.search = q.toString();
      return u.href;
    }

    load(url, push, focus) {
      var self = this;
      var swap = this.querySelector('[data-swap]');
      if (!swap || !window.fetch || !window.DOMParser) { window.location.href = url; return; }
      if (this._ac) this._ac.abort();
      this._ac = window.AbortController ? new AbortController() : null;
      this.setAttribute('aria-busy', 'true');
      swap.classList.add('is-loading');
      var closed = this.closeDrawer(true);
      var request = fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' }, signal: this._ac ? this._ac.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); });
      Promise.all([request, closed])
        .then(function (res) {
          var html = res[0];
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('tea-lab-collection[data-id="' + self._id + '"] [data-swap]');
          if (!next) throw new Error('no region');
          swap = self.querySelector('[data-swap]') || swap;
          swap.innerHTML = next.innerHTML;
          swap.classList.remove('is-loading');
          self.removeAttribute('aria-busy');
          if (push) { history.pushState(null, '', url); self._pushed = true; }
          self.observeCards();
          self.settle(focus);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          window.location.href = url;
        });
    }

    /* On page load the first cards wait for the heading to finish its intro (measured, so a slow script never adds extra delay). */
    leadDelay() {
      try {
        var el = document.querySelector('.tlc__hero.has-intro .tlc__rule') || document.querySelector('.tlc__hero.has-intro .tlc__lead');
        if (!el || !el.getAnimations) return 0;
        var a = el.getAnimations()[0];
        if (!a || a.playState === 'finished') return 0;
        return Math.max(0, 850 - (+a.currentTime || 0)) / 1000;
      } catch (err) { return 0; }
    }

    /* Cards stay hidden (by CSS) until they scroll into view; the ones that appear together are staggered left to right. */
    observeCards() {
      var self = this;
      if (this._io) { this._io.disconnect(); this._io = null; }
      var cards = Array.prototype.slice.call(this.querySelectorAll('.tlc__item[data-card]'));
      var show = function (list) { list.forEach(function (c) { c.classList.add('is-in'); }); };
      try {
        var editor = window.Shopify && window.Shopify.designMode;
        if (!this.animated() || editor || !('IntersectionObserver' in window)) { show(cards); this.setAttribute('data-ready', ''); return; }
        this.setAttribute('data-ready', '');
        this._io = new IntersectionObserver(function (entries) {
          var seen = entries.filter(function (e) { return e.isIntersecting; });
          seen.sort(function (a, b) {
            var ra = a.boundingClientRect, rb = b.boundingClientRect;
            return (Math.round(ra.top / 8) - Math.round(rb.top / 8)) || (ra.left - rb.left);
          });
          var lead = self._led ? 0 : self.leadDelay();
          if (seen.length) self._led = true;
          seen.forEach(function (e, i) {
            if (lead > 0) e.target.style.setProperty('--tlc-lead', lead.toFixed(2) + 's');
            e.target.style.setProperty('--n', Math.min(i, 8));
            e.target.classList.add('is-in');
            self._io.unobserve(e.target);
          });
        }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });
        cards.forEach(function (c) { self._io.observe(c); });
      } catch (err) {
        show(cards);
        this.setAttribute('data-ready', '');
      }
    }

    settle(focus) {
      var count = this.querySelector('[data-count]');
      var live = this.querySelector('[data-live]');
      if (live && count) live.textContent = count.textContent;
      if (count && this.animated()) count.classList.add('is-tick');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (focus === 'sort') {
        var s = this.querySelector('[data-sort]');
        if (s) s.focus({ preventScroll: true });
      } else if (count) {
        count.focus({ preventScroll: true });
      }
      if (focus !== 'sort') {
        var bar = this.querySelector('.tlc__bar') || this;
        var top = bar.getBoundingClientRect().top;
        if (top < 0 || focus === 'top') {
          window.scrollTo({ top: Math.max(0, window.pageYOffset + top - 8), behavior: reduce ? 'auto' : 'smooth' });
        }
      }
    }
  }

  customElements.define('tea-lab-collection', TeaLabCollection);
})();
